'use strict';

namespace Core {

    class SelectedTransferSummary {

        transfer: any;

        public legs :any[];
        public show :boolean = false;

        constructor(
            private $scope: ng.IScope
        ) {

            let stop = this.$scope.$watch('sts.transfer', v => {
                if (v) {
                    this.init(v);
                    stop();
                }
            });

        }

        private init(transfer :any) :void {
            let legs :any[] = [];
            if (transfer.Details.Itinerary.OutboundLeg) {
                legs.push({...transfer.Details.Itinerary.OutboundLeg, isOutboundLeg: true});
            }
            if (transfer.Details.Itinerary.InboundLeg) {
                legs.push({...transfer.Details.Itinerary.InboundLeg, isOutboundLeg: false});
            }

            this.legs = (<any>[]).concat(legs);
            this.show = true;
        }

    }

    angular
        .module('core')
        .directive('selectedTransferSummary', (): ng.IDirective => {

        return {
            scope: {},
            controller: SelectedTransferSummary,
            controllerAs: 'sts',
            replace: true,
            bindToController: {
                transfer: '=',
                titleText: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=SelectedTransferSummary'
        };

    });

}
